// extracted by mini-css-extract-plugin
export var base = "Button-module--base--17011";
export var caution = "Button-module--caution--8ce57";
export var filled = "Button-module--filled--c8787";
export var invariable = "Button-module--invariable--af52d";
export var key = "Button-module--key--f837c";
export var loading = "Button-module--loading--ba1f1";
export var outlined = "Button-module--outlined--aaac2";
export var solid = "Button-module--solid--94423";